import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import {createStyles, makeStyles} from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import {useHistory} from "react-router-dom";
import {fade} from "@material-ui/core";

const useStyles = makeStyles(theme =>
    createStyles({
        root: {
            padding: 0,
            height: 'calc(100vh - 145px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        appBar:{
            backgroundColor: fade(theme.palette.primary.main, 0.25)
        },
        appBarBottom: {
            // backgroundColor: theme.palette.common.white,
            border: "none",
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4)
        },
        logoBottom: {
            marginRight: theme.spacing(4),
            [theme.breakpoints.down('sm')]:{
                maxHeight: '50%'
            }
        },
        footerItem: {
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down('sm')]:{
                fontSize: '0.8rem'
            }
        },
        copyright:{
            [theme.breakpoints.down('sm')]:{
                fontSize: '0.8rem'
            }
        }
    })
)

const ErrorView = props => {
    const classes = useStyles();
    const history = useHistory();
    return (
        <React.Fragment>
            <CssBaseline/>
            <AppBar position="fixed" color="primary" elevation={0} className={classes.appBar}>
                <Container maxWidth={"lg"}>
                    <Toolbar variant="dense">
                        <Typography variant="h6" className={classes.title}>
                            {/*<div>Repozytorium Standardów Informacyjnych</div>*/}
                            <div>
                                <img
                                    src="./images/logo_gus_pl.svg"
                                    alt="GUS RSI logo"
                                    style={{cursor: "pointer", maxHeight: 44}}
                                    onClick={() => history.push('/')}
                                />
                            </div>
                        </Typography>
                    </Toolbar>
                </Container>
            </AppBar>
            <Container maxWidth={false} className={classes.root}>
                {props.children}
            </Container>
            <Container maxWidth={"xl"}>
                <AppBar position="static" color="transparent" className={classes.appBarBottom} elevation={0}>
                    <Toolbar>
                        <Grid container>
                            <Grid item xs={12} md={6} className={classes.footerItem}>
                                <img src={'./images/gusMono.png'} alt="GUS logo" className={classes.logoBottom}/>
                                <Box>
                                    Aleja Niepodległości 208 <br/>
                                    00-925 Warszawa<br/>
                                    <a
                                        href="https://stat.gov.pl"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{color: "inherit", textDecoration: "inherit"}}
                                    >Przejdź do Portalu GUS</a>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6} className={classes.footerItem}>
                                <Typography variant="body2" style={{flex: 1, textAlign: "right"}}>
                                    <em className={classes.copyright}>Copyright © 2018-{new Date().getFullYear()} Główny Urząd Statystyczny</em>
                                </Typography>
                            </Grid>

                        </Grid>
                    </Toolbar>
                </AppBar>
            </Container>
        </React.Fragment>

    )
}

export default ErrorView
